import { Action } from '@ngrx/store';

/**
 * OrdersActionTypes
 */
export const enum KpiActionTypes {
  LOAD_KPI = '[KPI] Load KPI',
  LOAD_KPI_SUCCESS = '[KPI] Load KPI Success',
  LOAD_KPI_ERROR = '[KPI] Load KPI Error',
  SAVE_LOCATION = '[KPI] Save Location',
}

/**
 * LoadOrders
 */
interface LoadKpi extends Action {
  type: KpiActionTypes.LOAD_KPI;
  payload: any;
}

/**
 * LoadOrdersSuccess
 */
interface LoadKpiSuccess extends Action {
  type: KpiActionTypes.LOAD_KPI_SUCCESS;
  payload: any;
}

/**
 * LoadOrdersError
 */
interface LoadKpiError extends Action {
  type: KpiActionTypes.LOAD_KPI_ERROR;
  payload: any;
}

interface SaveLocation extends Action {
  type: KpiActionTypes.SAVE_LOCATION;
  payload: any;
}

/**
 * OrdersActions
 */
export type KpiActions = LoadKpi | LoadKpiSuccess | LoadKpiError | SaveLocation;
